module.exports = __webpack_public_path__ + "img/couples-057.d453b6aa.jpg";